import React, { useEffect, useState } from 'react';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import View from 'src/components/view';
import utils from 'src/components/utils';
import LinksPagamento from 'src/components/links_pagamento';

function LinksPagamentoPedido() {
  const [crud] = useState({ data: {}, changed: {} });
  const [ready, setReady] = useState(false);
  const [idPgto, setIdPgto] = useState(null);
  const idPedido = utils.getPath(2);

  useEffect(() => {
    utils.execute(crud, 'listar_pagamentos_pedido?id_pedido=' + idPedido, null, function (res) {
      const pgto = [].concat(res.data || []).find((p) => p && p.codigo === 'LINK_EXTERNO');

      setIdPgto(pgto?.id);
      setReady(true);
    });
  }, []);

  const voltar = function () {
    window.location.href = '/crud/HubPedidoVenda/' + idPedido;
  };

  return (
    <View name="links-pagamento">
      <Paper className="ui-links-pagamento" style={{ padding: '16px' }}>
        <h5>{utils.lng('links_pagamento', 'Links de pagamento')}</h5>
        {ready && <LinksPagamento id_hub_ped_venda_pgto={idPgto} crud={crud} exibirDetalhesPagamento />}
        {!ready && (
          <div className="ui-loading">
            <i className="fas fas fa-circle-notch fa-spin"></i>
          </div>
        )}
        <div style={{ textAlign: 'right', marginTop: '16px' }}>
          <Button variant="outlined" onClick={voltar}>
            {utils.lng('voltar', 'Voltar')}
          </Button>
        </div>
      </Paper>
    </View>
  );
}

export default LinksPagamentoPedido;
